/**
 * Envío PJ-1 · personajes (panel "Personajes" de la Vista Edición).
 * Los mismos personajes que usa LMX: el servidor llama a los mismos handlers del MCP.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ref = (r) => encodeURIComponent(r);

export const characterService = {
  async list() {
    const { data } = await axios.get(`${API}/characters`);
    return data.characters || [];
  },
  async get(r) {
    const { data } = await axios.get(`${API}/characters/${ref(r)}`);
    return data;
  },
  async create(payload) {
    const { data } = await axios.post(`${API}/characters`, payload);
    return data;
  },
  async update(r, patch) {
    const { data } = await axios.patch(`${API}/characters/${ref(r)}`, patch);
    return data;
  },
  // Envío PJ-2 · borrado definitivo (la Biblioteca confirma antes).
  async remove(r) {
    const { data } = await axios.delete(`${API}/characters/${ref(r)}`);
    return data;
  },
  async undo(r, versionId = null) {
    const { data } = await axios.post(`${API}/characters/${ref(r)}/undo`,
      versionId ? { version_id: versionId } : {});
    return data;
  },
  async assetUsage(assetId) {
    try {
      const { data } = await axios.get(`${API}/characters/asset-usage/${ref(assetId)}`);
      return data.used_by || [];
    } catch { return []; }   // sin personajes o sin red: no bloquea el borrado
  },
  async cast(projectId) {
    const { data } = await axios.get(`${API}/projects/${projectId}/cast`);
    return data.cast || [];
  },
  async changeCast(projectId, { add = [], remove = [] }) {
    const { data } = await axios.post(`${API}/projects/${projectId}/cast`, { add, remove });
    return data.cast || [];
  },
};

export default characterService;
